import { toast } from "react-toastify";
import { patchApi } from "../../utils/DatabaseHelper";

/**
 * 
 * @param {*} mitarbeiterId 
 */
export async function toggleArchiveStatus(mitarbeiterId, is_archived) {
    // logger.log("Archiviere: ", mitarbeiterId);
    const id = toast.loading(`Mitarbeiter ${is_archived ? 'archivieren...' : 're-aktiviert...' }.`, { position: 'top-center' });
    try {
      const resp = await patchApi('mitarbeiter', mitarbeiterId, { is_archived });
      toast.update(id, { render: resp.message, type: 'success', isLoading: false, autoClose: 5000 });
    } catch (err) {
      toast.update(id, { render: err.message, type: 'error', isLoading: false, autoClose: 5000 });
    } finally {
        global.emitter.emit("REFRESH_TABLE_DATA");
    }
}